import React, { useEffect, useState, useCallback } from "react";
import { fetchUserSessions } from "../services/api";

const emptyFilters = {
  phone: "",
  path: "",
  start_date: "",
  end_date: "",
  page: 1,
  per_page: 10,
};

const formatDateTime = (value) => (value ? new Date(value).toLocaleString() : "N/A");

const UserSessions = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({});
  const [filters, setFilters] = useState(emptyFilters);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetchUserSessions(filters);
      setData(res.data);
      setPagination(res.pagination);
    } catch (err) {
      console.error("Failed to fetch user sessions:", err);
      setData([]);
      setPagination({});
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleFilterChange = (e) => {
    setFilters((prev) => ({ ...prev, [e.target.name]: e.target.value, page: 1 }));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchData();
  };

  const handleReset = () => setFilters(emptyFilters);

  const handlePageChange = (newPage) => {
    setFilters((prev) => ({ ...prev, page: newPage }));
  };

  return (
    <div className="page-container">
      <h2 className="page-title">User Sessions</h2>

      <form className="filter-form" onSubmit={handleSearch}>
        <input
          type="text"
          name="phone"
          value={filters.phone}
          onChange={handleFilterChange}
          className="filter-input"
          placeholder="Search phone number"
        />
        <input
          type="text"
          name="path"
          value={filters.path}
          onChange={handleFilterChange}
          className="filter-input"
          placeholder="Search path (e.g. /my-did)"
        />
        <input
          type="date"
          name="start_date"
          value={filters.start_date}
          onChange={handleFilterChange}
          className="filter-input"
        />
        <input
          type="date"
          name="end_date"
          value={filters.end_date}
          onChange={handleFilterChange}
          className="filter-input"
        />
        <button type="submit" className="filter-btn">Search</button>
        <button type="button" className="filter-btn reset-btn" onClick={handleReset}>Reset</button>
      </form>

      <div className="table-container">
        <table className="call-logs-table">
          <thead>
            <tr className="table-header-row">
              <th className="table-header">#</th>
              <th className="table-header">USER ID</th>
              <th className="table-header">PHONE</th>
              <th className="table-header">PATH</th>
              <th className="table-header">APP VERSION</th>
              <th className="table-header">PLATFORM</th>
              <th className="table-header">DEVICE MODEL</th>
              <th className="table-header">DEVICE NAME</th>
              <th className="table-header">OS VERSION</th>
              <th className="table-header">DEVICE TYPE</th>
              <th className="table-header">DEVICE ID</th>
              <th className="table-header">LOCALE</th>
              <th className="table-header">CREATED AT</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="13" className="loading-cell">Loading...</td></tr>
            ) : data.length === 0 ? (
              <tr><td colSpan="13" className="empty-cell">No records found</td></tr>
            ) : (
              data.map((item) => (
                <tr key={item.id} className="table-row">
                  <td className="table-cell">{item.id}</td>
                  <td className="table-cell">{item.user_id ?? "N/A"}</td>
                  <td className="table-cell">{item.phone_number || "N/A"}</td>
                  <td className="table-cell">{item.path || "N/A"}</td>
                  <td className="table-cell">{item.app_version || "N/A"}</td>
                  <td className="table-cell">{item.platform || "N/A"}</td>
                  <td className="table-cell">{item.device_model || "N/A"}</td>
                  <td className="table-cell">{item.device_name || "N/A"}</td>
                  <td className="table-cell">{item.device_os_version || "N/A"}</td>
                  <td className="table-cell">{item.device_type || "N/A"}</td>
                  <td className="table-cell">{item.device_id || "N/A"}</td>
                  <td className="table-cell">{item.device_locale || "N/A"}</td>
                  <td className="table-cell">{formatDateTime(item.created_at)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {pagination.total_items > 0 && (
        <div className="pagination-container">
          <div className="pagination-info">
            Showing {((pagination.current_page - 1) * filters.per_page) + 1}–{Math.min(pagination.current_page * filters.per_page, pagination.total_items)} of {pagination.total_items}{' '}
            sessions (Page {pagination.current_page} of {pagination.total_pages})
          </div>
          <div className="pagination-buttons">
            <button
              onClick={() => handlePageChange(pagination.current_page - 1)}
              disabled={!pagination.has_prev}
              className={`pagination-btn ${!pagination.has_prev ? 'disabled' : ''}`}
            >
              Previous
            </button>
            <button
              onClick={() => handlePageChange(pagination.current_page + 1)}
              disabled={!pagination.has_next}
              className={`pagination-btn ${!pagination.has_next ? 'disabled' : ''}`}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserSessions;
